export const skills = [
  "Html",
  "Css",
  "JavaScript",
  "Terminal",
  "Devtools",
  "Flex and Grid",
  "Normalize",
  "BEM",
  "GitHub and GitHub Pages",
  "Mark down and readme",
  "Open graph and icon",
  "Object and Array",
  "Immutability",
  "JSX",
  "React",
  "React Router",
  "DOM tree",
  "Hooks (useState, useEffect etc.",
  "setTimeout, setInterval",
  "Styled Components",
  "Local Storage (also in React)",
  "Api",
  "Axios",
  "Promise, async/await",
  "Redux",
  "Redux Toolkit",
  "npm",
  "json",
  "Scrum",
  "Team Work",
  "Pull requests",
  "Review in GitHub",
  "GitHub branches",
  "Responsiveness (media queries)",
  "Figma",
  "Trello",
  "TypeScript",
  "TypeScript + React",
  "TanStack Query",
  "Gemini, ChatGPT",
  "Cursor",
  "GitHub Copilot"
];

export const nextSkills = [
  "AI",
  "Gems",
  "LLM for VS Code",
  "SQL",
  "Next.js",
  "More about npm",
  "More about json",
  "More about team work",
  "More about Scrum",
  "More about Pull requests",
  "More about review",
];